import React from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../errorHandling/error-fallback-page';
import { handleBoundaryError } from '../../utils/globalErrorHandler';
import LoginRedirect from "./LoginRedirect";

/**
 * PrivateRoute - Route wrapper that requires a logged-in user.
 * Redirects unauthenticated visitors to `/login`.
 * Wraps the rendered component in an ErrorBoundary.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.component - The component to render for authenticated users.
 * @returns {JSX.Element}
 */
export default function PrivateRoute({ component: Component, ...rest }) {
  const { currentUser } = useAuth();

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleBoundaryError}>
    <Route
      {...rest}
      render={(props) => {
        return currentUser ? (
          <Component {...props} />
        ) : (
          <LoginRedirect />
        );
      }}
    ></Route></ErrorBoundary>
  );
}
